import type { TypedUseSelectorHook } from 'react-redux';
import { useDispatch, useSelector, useStore } from 'react-redux';
import type { Store } from 'redux';

import type { AppDispatch, RootState } from '@/store';

export { shallowEqual } from 'react-redux';

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
export const useAppStore = (): Store<RootState> => useStore<RootState>();
